"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormArray = void 0;
const react_1 = require("react");
const uuid = require("uuid");
const utils_1 = require("./utils");
function useFormArray(args) {
    const { minItems, onChange, onError } = args;
    const value = buildValue(args === null || args === void 0 ? void 0 : args.value, minItems);
    const [errors, setErrors] = (0, react_1.useState)(value.map(v => null));
    const ctx = (0, react_1.useMemo)(() => ({
        ids: value.map(v => uuid.v4()),
    }), []);
    function handleChange(index, subValue) {
        onChange === null || onChange === void 0 ? void 0 : onChange([
            ...value.slice(0, index),
            subValue,
            ...value.slice(index + 1),
        ]);
    }
    function handleError(index, error) {
        const newErrors = [
            ...errors.slice(0, index),
            error,
            ...errors.slice(index + 1),
        ];
        setErrors(newErrors);
        onError === null || onError === void 0 ? void 0 : onError((0, utils_1.stripArray)(newErrors));
    }
    function addForm() {
        ctx.ids = [
            ...ctx.ids,
            uuid.v4(),
        ];
        setErrors([
            ...errors,
            null,
        ]);
        onChange === null || onChange === void 0 ? void 0 : onChange([
            ...value,
            {},
        ]);
    }
    function removeForm(index) {
        ctx.ids = [
            ...ctx.ids.slice(0, index),
            ...ctx.ids.slice(index + 1),
        ];
        const newErrors = [
            ...errors.slice(0, index),
            ...errors.slice(index + 1),
        ];
        setErrors(newErrors);
        onError === null || onError === void 0 ? void 0 : onError((0, utils_1.stripArray)(newErrors));
        onChange === null || onChange === void 0 ? void 0 : onChange([
            ...value.slice(0, index),
            ...value.slice(index + 1),
        ]);
    }
    return {
        formsArray: value.map((v, i) => ({
            key: ctx.ids[i],
            value: v,
            removeForm: () => removeForm(i),
            onChange: subValue => handleChange(i, subValue),
            onError: error => handleError(i, error),
        })),
        addForm,
    };
}
exports.useFormArray = useFormArray;
function buildValue(initialValue, minItems) {
    const value = (0, utils_1.isNullish)(initialValue) ? [] : Array.isArray(initialValue) ? initialValue : [initialValue];
    if ((0, utils_1.isNullish)(minItems)) {
        return value;
    }
    if (value.length >= minItems) {
        return value;
    }
    return [
        ...value,
        ...Array(minItems - value.length).fill({}),
    ];
}
//# sourceMappingURL=useFormArray.js.map